import { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import { Link } from "react-router-dom";
import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import NewsTable from "../Common/NewsTable";

const HonoraryNews = () => {
  const [news, setNews] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getHonoraryNews().then((data) => setNews(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Honorary news")}
      <Divider align="center">
        <h1>Honorary news</h1>
      </Divider>
      <div className="privacy-terms">
        This page gathers the latest notable news on honorary consuls;{" "}
        <span className="emphasis-warning">
          it does not provide updates on routine matters such as appointments or
          visits
        </span>
        . Information is also accessible via a dedicated{" "}
        <Link
          to="https://www.linkedin.com/showcase/honorary-consuls/"
          target="_blank"
          rel="noreferrer"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          LinkedIn page
        </Link>{" "}
        and{" "}
        <Link
          to="/the-consular-newsletter"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          The Consular Newsletter
        </Link>
        . Are you a recognized press body or an honorary consul? Interested in
        highlighting specific news? Please feel free to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
      <br />
      <NewsTable data={news} searchEnabled longDescription />
    </div>
  );
};

export default HonoraryNews;
